import '.f{position:fixed;}.ssr-plugin'
import '.be{top:0px;}.ssr-plugin'
import '.bj{left:0px;}.ssr-plugin'
import '.bk{right:0px;}.ssr-plugin'
import '.bl{bottom:0px;}.ssr-plugin'
import '.bm{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.bn{z-index:998;}.ssr-plugin'
import '.bo{transition:opacity 0.3s ease;}.ssr-plugin'
import '.bp{height:100vh;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.bq{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.br{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.bs{justify-content:space-between;}.ssr-plugin'
import '.bt{padding:1.5rem;}.ssr-plugin'
import '.bu{border-bottom:var(--border-default);}.ssr-plugin'
import '.ao{flex-shrink:0;}.ssr-plugin'
import '.b1{flex:1;}.ssr-plugin'
import '.bv{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="f be bj bk bl bm bn bo"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="f be bp l t bq br a b"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a r bs bt bu ao"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="b1 bv bt"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
